import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { PcodeAds } from '../../../typings/pcode';
import { State } from '../../../typings/state';
import { TDispatchProps, TStateProps } from '../../../typings/utils';
import { CanvasAction } from '../../common/actions';
import { Page } from '../../common/typings';
import {
    adEnd,
    closeLongUploadPopup,
    createVideoCreative,
    initVideoData,
    optionChange,
    returnSelect,
    saveName,
    toggleOptionGroupVisibility
} from '../actions';
import { selectVideoCreativeState } from '../selectors';

import { AddVideoCreative, AddVideoCreativeProps } from './AddVideoCreative';
import { getIsCpmAudio } from './helpers';
import { getIsVideoAddition } from './helpers';

export type StateProps = TStateProps<AddVideoCreativeProps>;
type OwnProps = {
    onCancel: () => void;
    creativesSelect: (ids: number[]) => void;
    videoPreviewData?: PcodeAds;
};
export type DispatchProps = TDispatchProps<AddVideoCreativeProps, OwnProps>;

export const mapStateToProps = (state: State): StateProps => {
    const {
        isLoading,
        isSaving,
        creativeOptions,
        returnPage,
        error,
        pcodeVideoPreviewData,
        longUploadPopupVisible,
        isPreviewLoading,
        submitEnabled,
        shouldCreate
    } = selectVideoCreativeState(state.canvasEditor.canvas.addCreative);
    const sharedData = state.canvasEditor.sharedData;

    return {
        isLoading,
        isSaving,
        creativeOptions,
        returnPage,
        error,
        videoPreviewData: pcodeVideoPreviewData,
        isAudio: getIsCpmAudio(sharedData),
        isVideoAddition: getIsVideoAddition(sharedData),
        longUploadPopupVisible,
        isPreviewLoading,
        submitEnabled,
        shouldCreate
    };
};

const mapDispatchToProps = (dispatch: Dispatch<CanvasAction>, ownProps: OwnProps): DispatchProps => {
    return {
        onOptionChange: (groupName: string, name: string, value: string): void => {
            dispatch(optionChange(groupName, name, value));
        },
        onGroupVisibleChange: (groupName: string): void => {
            dispatch(toggleOptionGroupVisibility(groupName));
        },
        onSaveName: (name: string): void => {
            dispatch(saveName(name));
        },
        onSave: (): void => {
            dispatch(createVideoCreative(ownProps.creativesSelect));
        },
        initVideoData: (): void => {
            dispatch(initVideoData(ownProps.videoPreviewData));
        },
        closeLongUploadPopup: (): void => {
            dispatch(closeLongUploadPopup());
        },
        onAdEndCallback: (): void => {
            // пока не понятно кто будет слушать событие на окончание проигрывания видео
            dispatch(adEnd());
        },
        onReturnClick: (page?: Page): void => {
            dispatch(returnSelect(page));
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): AddVideoCreativeProps => {
    const { creativesSelect, videoPreviewData, ...otherProps } = ownProps;

    return {
        ...stateProps,
        ...dispatchProps,
        ...otherProps
    };
};

export const AddVideoCreativeContainer = connect<StateProps, DispatchProps, OwnProps, AddVideoCreativeProps>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(AddVideoCreative);
